/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanyEditCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanySubscriptionCtrl', ["LoadedSubscription", "$stateParams", "$scope", "title", "dialog", "$q", "notificationService", function(LoadedSubscription, $stateParams, $scope, title, dialog, $q, notificationService) {
  $scope.loading = LoadedSubscription.get($stateParams.id);

  $scope.plan = {frequency: ''};
  $scope.frequencies = [
    {name: 'Annually', value: 'yearly'},
    {name: 'Monthly', value: 'monthly'}
  ];

  var currentFrequency = '';
  var prefixRegex = /^[^-]+-/;

  notificationService.setShowNotifications(false);

  title.set('Manage Payment Details');

  function diffDays(date1, date2) {
    var oneDay = 24 * 60 * 60 * 1000;
    var diffDays = Math.round(Math.abs((date1.getTime() - date2.getTime()) / oneDay));
    return diffDays;
  }

  $scope.loading.then(function(result) {
    $scope.subscription = result;
    $scope.daysLeft = diffDays(new Date(result.nextAssessmentAt), new Date());

    // Trim the leading part of the handle, if present, to leave only the frequency.
    // e.g. "2023-monthly" becomes "monthly". "demo" remains unchanged.
    $scope.plan.prefix = result.product.handle.match(prefixRegex) || [''];
    $scope.plan.frequency = result.product.handle.replace(prefixRegex, '');
    currentFrequency = result.product.handle.replace(prefixRegex, '');
  });

  $scope.updatePayment = function() {
    dialog.open({
      template: '<div class="modal-body"><iframe src="' + decodeURIComponent($scope.subscription.selfServiceUrl) + '" width="722px" height="970px"/></div>',
      size: 'chargify-payment'
    }).catch(function() {
      $scope.plan.frequency = currentFrequency;
    });
  };

  $scope.choosePlan = function() {
    // Preflight confirmation dialog promise
    var confirmationDialog = $q.defer();
    $scope.confirmationPending = confirmationDialog.promise;

    // intermediate promise to get the result of the payment method
    var checkingPayment = $q.defer();
    $scope.checkingPayment = checkingPayment.promise;

    dialog.open({
      templateUrl: 'modules/settings/company/subscriptionconfirmdialog.tpl.html',
      controller: 'SettingsCompanySubscriptionConfirmationDialogCtrl',
      size: 'sm',
      resolve: {
        newFrequency: function() {
          return $scope.plan.frequency;
        }
      }
    }).then(function(result) {
      if (result) {
        if ($scope.subscription.hasPaymentInfo) {
          // If we already have payment information, then skip the dialog, and move on to the next step
          checkingPayment.resolve();
          updateCurrentFrequency();
        } else {
          templateString = '<div class="modal-body"><iframe src="' + decodeURIComponent($scope.subscription.selfServiceUrl) + '" width="722px" height="970px" /></div>';
          dialog.open({
            template: templateString,
            size: 'chargify-payment'
          }).then(function() {}, function() {
            // We don't know if the user actually entered their details. So we need to re-check the subscription to see if we now have payment details
            LoadedSubscription.get($stateParams.id).then(function(result) {
              $scope.subscription = result;
              if (result.hasPaymentInfo) {
                checkingPayment.resolve();
                updateCurrentFrequency();
              } else {
                checkingPayment.reject();
                $scope.plan.frequency = currentFrequency;
              }
            });
          });
        }
      } else {
        checkingPayment.reject();
        $scope.plan.frequency = currentFrequency;
      }
    }).catch(function() {
      $scope.plan.frequency = currentFrequency;
    });

    $scope.checkingPayment.then(function() {
      // The user has got payment details. Now we can update the plan
      $scope.updatingFrequency = LoadedSubscription.choosePlan($stateParams.id, $scope.plan.prefix[0] + $scope.plan.frequency)
        .then(function(result) {
          $scope.subscription = result.data;
          updateCurrentFrequency();
        }, function(error) {
          dialog.alert(error);
        });
    });
  };

  $scope.showAsteriskPayment = function() {
    return !$scope.subscription.hasPaymentInfo;
  };

  $scope.showAsteriskFrequency = function() {
    return currentFrequency == '' || currentFrequency == 'demo';
  };

  updateCurrentFrequency = function() {
    currentFrequency = $scope.subscription.product.handle.replace(prefixRegex, '');
  };
}]);
